import HorizontalLogoSVG from '../assets/icons/Horizontal Logo - Gold.svg';
import LogomarkSVG from '../assets/icons/Logomark - Gold.svg';

export const LOGO_ASSETS = {
  // SVG versions (preferred for scalability)
  horizontal: {
    svg: HorizontalLogoSVG,
    alt: 'Falcon Horizontal Logo',
  },
  logomark: {
    svg: LogomarkSVG,
    alt: 'Falcon Logomark',
  },
} as const;

export type LogoType = keyof typeof LOGO_ASSETS;
